module.exports = __webpack_public_path__ + "img/z5.efd69286.jpg";